// extracted by css-extract-rspack-plugin
export default {"modulesList":"modulesList-gM6i6C"};